import BooleanField from '../../../../components/BooleanField'
import EditableField from '../../../../components/EditableFields'
import React from 'react'
import DescripcionActividadSolicitud from '../components/infoSolicitudes'

const ClienteView = ({
  solicitud,
  isCliente,
  tipoServiciosListAdmin,
  handleSave,
  materiasOptions,
  auxiliarBusqueda,
  busquedaClientesOptions,
  estadoSolicitudVisibles
}) => {
  
  return (
    <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          <EditableField
            field="Servicio"
            label="Tipo de Servicio"
            value={solicitud.Servicio}
            type="react-select"
            options={tipoServiciosListAdmin}
            onSave={handleSave}
          />

          <EditableField
            field="materia"
            label="Materia"
            value={solicitud.materia}
            type="react-select"
            options={materiasOptions}
            isAdmin={isCliente}
            onSave={handleSave}
            placeholder="Ingrese la materia"
          />

          <EditableField
            field="fechaentrega"
            label="Fecha de entrega"
            value={solicitud.fechaentrega}
            type="datetime"
            isAdmin={isCliente}
            onSave={handleSave}
            placeholder="Ingrese la fecha"
          />  
          
          <EditableField
            label="Fecha de sistema"
            value={solicitud.fechasistema}
            type="datetime"
            isAdmin={false}
            onSave={handleSave}
          />  


          {/* PODER VER INFO DE UNAD COMPLETO */}
          
        </div>
      
        <div className="bg-white p-4 rounded-lg border">
          
          <DescripcionActividadSolicitud 
            key={solicitud.ultimaModificacion} 
            solicitud={solicitud}
            isAdmin = {true}
            onUpdateSolicitud = {handleSave}
            />
          
          <p className="text-sm text-gray-600 mt-2">{solicitud.formato}</p>
        </div>
      </div>
  )
}

export default ClienteView